module.exports = __webpack_public_path__ + "img/Meganisi.03185b24.png";